/**
 * `ContextMenu` (W1-12 ui-kit-i18n; contract ContextMenuProps): Radix context menu on `children` (right click,
 * long press on touch, the Menu key / Shift+F10 through the browser's contextmenu event). Same items, keyboard
 * and bridge behaviour as Menu. The child element must accept a ref and DOM props; other content is wrapped in
 * a block element.
 */

import * as CM from '@radix-ui/react-context-menu';
import { isValidElement } from 'react';
import { asTriggerChild } from './internal/commandButton';
import { MenuItems, menuStyles, type MenuKit } from './internal/menuItems';
import type { ContextMenuProps } from './types';

const KIT: MenuKit = {
  Item: CM.Item,
  CheckboxItem: CM.CheckboxItem,
  ItemIndicator: CM.ItemIndicator,
  Separator: CM.Separator,
  Sub: CM.Sub,
  SubTrigger: CM.SubTrigger,
  SubContent: CM.SubContent,
  Portal: CM.Portal,
};

export function ContextMenu(props: ContextMenuProps & { readonly label?: string }) {
  const child = isValidElement(props.children) ? asTriggerChild(props.children) : <div>{props.children}</div>;
  return (
    <CM.Root>
      <CM.Trigger asChild>{child}</CM.Trigger>
      <CM.Portal>
        <CM.Content className={menuStyles.content} collisionPadding={8} loop aria-label={props.label}>
          <MenuItems kit={KIT} items={props.items} />
        </CM.Content>
      </CM.Portal>
    </CM.Root>
  );
}
